import React, { Component } from "react"
import { connect } from 'react-redux'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";

import {
    getSearchDirectoryInfoAction, getAllOrgUnitsAction, clearSearchDirectoryInfoAction,
} from '../../redux/actions/MasterAction'

import {
    updateMR_DetailAction,
} from '../../redux/actions/MRAction'

import {
    updateEvaluationModalAction,
} from '../../redux/actions/MRAction'

import {
    setInputAction, clearModalAction
} from '../../redux/actions/ModalEmployeeAction'

import { msg } from '../../components/Notifications/MsgBox';
import utilityHelper from "../../helpers/helperUtil"
import { DropDownList } from "../core"

import { startLoadingAction, stopLoadingAction } from "../../redux/actions/AppAction.js"
import { json } from "body-parser";

class SearchEmployeeModal extends Component {

    constructor(props) {
        super(props)
        
        this.state = {
            ...props,
            q_empCode:'',
            q_empName:'',
            q_position:'',
            q_positionabbr:'',
            q_departmentCode:'',
            employeeSearchPIS:[],
            page: 0,
            rowsPerPage: 5,
            totalRecord:0,
        }
        this.handleClick = this.handleClick.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
    }

    componentDidMount() {
        this.props.getAllOrgUnits()
    }

    handleChange(event) {
        const { name, value } = event.target
       
        this.props.setInput(name, value);
        
      }

    handleClick(event, newPage) {

        console.log("SearchEmployeeModal.handleClick()");
        const { ModalEmployee } = this.props;

        let q_empCode = ModalEmployee.q_empCode;
        let q_empName = ModalEmployee.q_empName;
        let q_position = ModalEmployee.q_position;
        let q_positionabbr = ModalEmployee.q_positionabbr;
        let q_departmentCode = ModalEmployee.q_departmentCode;
        let q_departmentName = ModalEmployee.q_departmentName;
        let q_departmentABBR = ModalEmployee.q_departmentABBR;

        let q_secondmentFlag = 0
        let allq = (q_empCode == null ? '' : q_empCode) + (q_empName == null ? '' : q_empName) + (q_position == null ? '' : q_position) 
        + (q_positionabbr == null ? '' : q_positionabbr) + (q_departmentCode == null ? '': q_departmentCode) + (q_departmentName == null ? '' : q_departmentName) + (q_departmentABBR == null ? '': q_departmentABBR);
        
        if (ModalEmployee.key_table === "T_MR_DETAIL" && (ModalEmployee.key_empCode === "approver_code" || ModalEmployee.key_empCode === "receiver_code")){
            q_secondmentFlag = 1;
        }

        if (allq.length < 2) {
            msg.error('กรุณาระบุเงื่อนไขในการค้นหาอย่างน้อย 2 ตัวอักษร')
            return
        }

        let { page, rowsPerPage } = this.state;
        if(newPage)
        {
            page = newPage
        }else{
            page = 0
        }

        this.props.getSearchDirectoryInfo(q_empCode, q_empName, q_position, q_positionabbr ,q_secondmentFlag, q_departmentCode, q_departmentName, q_departmentABBR, page * rowsPerPage, rowsPerPage ).then((response) => {
            if (response.data != null && response.data.length > 0) {
                console.log("response")
                console.log(response)
                this.setState({
                    employeeSearchPIS: response.data,
                    totalRecord: response.data[0].totalRow,
                    page: page,
                    rowsPerPage: rowsPerPage
                })
            }

            if (!response.data) {
                msg.error("ไม่พบข้อมูล")
                return
            }
        })
    }


    chooseItem(item) {
        const { ModalEmployee } = this.props;

        let { key_table, key_empCode, key_empName } = ModalEmployee;
        if (item != null) {
            console.log("chooseItem");
            console.log("employeeId: " + item.employeeId)
            console.log("employeeNameTH: " + item.employeeNameTH)

            console.log("key_empCode: " + key_empCode)
            console.log("key_empName: " + key_empName)

            if (key_table === 'T_MR_DETAIL') {
                this.props.updateMR_Detail(item.employeeId, key_empCode);
                this.props.updateMR_Detail(item.iname + " " + item.employeeNameTH, key_empName);


                this.props.updateMR_Detail(item.employeeId, key_empCode);
                this.props.updateMR_Detail(item.iname + " " + item.employeeNameTH, key_empName);
                this.props.updateMR_Detail(item.employeeId, "approve_order_code");
                this.props.updateMR_Detail(item.iname + " " + item.employeeNameTH, "approve_order_name");
                this.props.updateMR_Detail(item.positionNameTH , "approve_order_position");
                this.props.updateMR_Detail(item.mobileNo , "approve_order_telephone");
                this.props.updateMR_Detail(item.eMailAddress , "approve_order_email");
            }
            else if (key_table === 'T_MR_DETAIL_NO_APPROVE') {
                this.props.updateMR_Detail(item.employeeId, key_empCode);
                this.props.updateMR_Detail(item.iname + " " + item.employeeNameTH, key_empName);
                this.props.updateMR_Detail(item.positionNameTH , "approve_order_position");
                this.props.updateMR_Detail(item.mobileNo , "approve_order_telephone");
                this.props.updateMR_Detail(item.eMailAddress , "approve_order_email");
            }
            else if (key_table === 'T_MR_VENDOR') {

                this.props.updateEvaluationModal({
                    ...this.props.evaluationModal,
                    [key_empCode]: item.employeeId,
                    [key_empName]: item.iname + " " + item.employeeNameTH,
                });
            }
            else if (key_table === 'M_USER' || key_table === 'T_GR_DETAIL') {

                if (window.onUserSearchEmployeeSelected) {
                    window.onUserSearchEmployeeSelected(
                        key_table,
                        item.employeeId,
                        item.employeeNameTH,
                        item

                    )
                }
            }
            else {
                if (window.onSearchEmployeeSelected) {
                    window.onSearchEmployeeSelected(
                        key_table,
                        item.employeeId,
                        item.employeeNameTH,
                        item

                    )
                }
            }

            if (this.props.onSelected) {
                this.props.onSelected(item)
            }
        }
        this.setState({ employeeSearchPIS: null, totalRecord : 0 , rowsPerPage : 5})
        
        if (this.props.onSelected) {
            this.props.clearSearchDirectoryInfo();
            this.props.clearModal();
        }
    }

    setOrg_Unit() {
     
        const { org_unit } = this.props
        let result = null
        result = utilityHelper.toSelectList_CombineFields(org_unit, "unitcode", "unitabbr", "unitcode")
        result.splice(0, 0, {"label":'- เลือกทั้งหมด -', "value":''})

        return result
    }

    async handleChangePage(event, newPage) {
        await this.setState({
            page: newPage
        })
        this.handleClick(event, newPage)
    }

    async handleChangeRowsPerPage(event) {
        await this.setState({
            rowsPerPage: event.target.value,
            page: 0
        })
        this.handleClick()
    }

    render() {

        //const { q_empCode, q_empName } = this.state;
        const { employeeSearchPIS } = this.state
        const { ModalEmployee } = this.props;
        let q_empCode = (ModalEmployee.q_empCode ? ModalEmployee.q_empCode : "");
        let q_empName = (ModalEmployee.q_empName ? ModalEmployee.q_empName : "");
        let q_position = (ModalEmployee.q_position ? ModalEmployee.q_position : "");
        let q_positionabbr = (ModalEmployee.q_positionabbr ? ModalEmployee.q_positionabbr : "");
        let q_departmentCode = (ModalEmployee.q_departmentCode ? ModalEmployee.q_departmentCode : "");
        let q_departmentName = (ModalEmployee.q_departmentName ? ModalEmployee.q_departmentName : "");
        let q_departmentABBR = (ModalEmployee.q_departmentABBR ? ModalEmployee.q_departmentABBR : "");

        console.log("employeeSearchPIS")
        console.log(employeeSearchPIS)
        // console.log("ModalEmployee")
        // console.log(ModalEmployee)

        return (
            <div className="modal fade sp-modal rrs-modal"  id="searchEmployeeModal" tabIndex={-1} role="dialog" aria-labelledby="searchEmployeeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document" style={{maxWidth:1040}}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchEmployeeModalLabel">ค้นหาข้อมูลพนักงาน</h5>
                            <input type="hidden" id="MR_DETAIL_Field_key"/>
                            <input type="hidden" id="MR_DETAIL_Field_val"/>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.chooseItem(null)}>
                                <span aria-hidden="true">×</span>
                            </button>
                          
                        </div>
                        
                        <div className="modal-body rrs-container">
                            <div className="rrs-detail3">
                                
                                <div className="row">
                                    <div className="col-6">
                                        <div className="rrs-form">

                                            <label htmlFor="txtEmpCode" className="rrs-label">รหัสพนักงาน</label>
                                            <div className="rrs-detail-data">
                                                <input autoComplete="off" type="text" className="form-control w-100"  placeholder="รหัสพนักงาน" id="q_empCode" name="q_empCode" onChange={this.handleChange} value={q_empCode} />
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="rrs-form">

                                            <label htmlFor="txtName" className="rrs-label">ชื่อ-สกุล</label>
                                            <div className="rrs-detail-data">
                                                <input autoComplete="off" type="text" className="form-control w-100"  placeholder="ชื่อ-สกุล" id="q_empName" name="q_empName" onChange={this.handleChange} value={q_empName} />
                                            </div>

                                        </div>
                                    </div>                                
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="rrs-form">
                                            <label htmlFor="txtEmpCode" className="rrs-label">ตำแหน่ง</label>
                                            <div className="rrs-detail-data">
                                                <input autoComplete="off" type="text" className="form-control w-100"  placeholder="ตำแหน่ง" id="q_position" name="q_position" onChange={this.handleChange} value={q_position} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="rrs-form">
                                            <label htmlFor="txtName" className="rrs-label">ตำแหน่ง (คำย่อ)</label>
                                            <div className="rrs-detail-data">
                                                <input autoComplete="off" type="text" className="form-control w-100"  placeholder="ตำแหน่ง (คำย่อ)" id="q_positionabbr" name="q_positionabbr" onChange={this.handleChange} value={q_positionabbr} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="rrs-form">
                                            <label htmlFor="txtEmpCode" className="rrs-label">ชื่อหน่วยงาน</label>
                                            <div className="rrs-detail-data">
                                                <input autoComplete="off" type="text" className="form-control w-100"  placeholder="ชื่อหน่วยงาน" id="q_departmentName" name="q_departmentName" onChange={this.handleChange} value={q_departmentName} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="rrs-form">
                                            <label htmlFor="txtName" className="rrs-label">ชื่อหน่วยงาน (คำย่อ)</label>
                                            <div className="rrs-detail-data">
                                                <input autoComplete="off" type="text" className="form-control w-100"  placeholder="ชื่อหน่วยงาน (คำย่อ)" id="q_departmentABBR" name="q_departmentABBR" onChange={this.handleChange} value={q_departmentABBR} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="row" >
                                    <div className="col-6">
                                        <div className="rrs-form">
                                            <label htmlFor="txtEmpCode" className="rrs-label">หน่วยงาน</label>
                                            <div className="rrs-detail-data">
                                                <DropDownList
                                                    key={`SearchEmployeeModal_${q_departmentCode}`}
                                                    name="q_departmentCode"
                                                    options={this.setOrg_Unit()}
                                                    onSelectChanged={this.handleChange}
                                                    selected={q_departmentCode}
                                                >
                                                </DropDownList>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                <div className="row">
                                    <div className="col-12" style={{textAlign:"center",paddingBottom:"10px",paddingTop:"5px"}}>
                                        <button className="rrs-btn-icon" onClick={this.handleClick}><i className="icon bt-search icon-xs"></i></button>  
                                        <label htmlFor="txtName" className="rrs-label" style={{width:'100%'}}>&nbsp;</label>
                                    </div>
                                </div>
                                
                                <div className="row no-gutters sp-table-content">
                                    <div className="col-12">
                                    
                                        <Table aria-labelledby="tableTitle" className="sp-table table rrs-table">
                                            <TableHead>
                                                <TableRow className="sp-table-header">
                                                    <TableCell className="th-table text-center" width="100px">รหัสพนักงาน</TableCell>
                                                    <TableCell className="th-table text-center" >ชื่อ-สกุล</TableCell>
                                                    <TableCell className="th-table text-center">ตำแหน่ง<br></br>(คำย่อ)</TableCell>
                                                    <TableCell className="th-table text-center">ชื่อหน่วยงาน</TableCell>
                                                    <TableCell className="th-table text-center" width="100px">ชื่อหน่วยงาน<br></br>(คำย่อ)</TableCell>
                                                    <TableCell className="th-table text-center" width="50px">Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    employeeSearchPIS && employeeSearchPIS.map((datas, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell>{datas.employeeId}</TableCell>
                                                            <TableCell>{datas.iname + " " + datas.employeeNameTH}</TableCell>
                                                            <TableCell>{datas.positionABBR}</TableCell>
                                                            <TableCell>{datas.departmentNameTH}</TableCell>
                                                            <TableCell>{datas.departmentABBR}</TableCell>
                                                            <TableCell>
                                                                <button className="btn btn-info btn-choose-item" data-dismiss="modal" aria-label="Close" onClick={() => this.chooseItem(datas)}>
                                                                    เลือก
                                                                </button>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            className="pager"
                                            rowsPerPageOptions={[5, 10, 25]}
                                            component="div"
                                            count={this.state.totalRecord}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            backIconButtonProps={{
                                                "aria-label": "previous page"
                                            }}
                                            nextIconButtonProps={{
                                                "aria-label": "next page"
                                            }}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </div>

                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        
        

        )
    }
}

const mapStateToProps = state => {
    const { MainRedux,MasterRedux, ModalEmployeeRedux} = state
    return {
    //   employeeSearchPIS: MasterRedux.employeeSearchPIS,
      ModalEmployee: ModalEmployeeRedux,
      evaluationModal: MainRedux.evaluationModal,
      org_unit: MasterRedux.org_unit,

    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      getSearchDirectoryInfo:(employeeCode,employeeName, positionName, positionABBR ,secondmentFlag, departmentCode, departmentName, departmentABBR, offset,limit) => dispatch(getSearchDirectoryInfoAction(employeeCode,employeeName, positionName, positionABBR ,secondmentFlag, departmentCode, departmentName, departmentABBR, offset,limit)),
      updateMR_Detail: (data, fieldName) => dispatch(updateMR_DetailAction(data, fieldName)),
      updateEvaluationModal: (data, fieldName) => dispatch(updateEvaluationModalAction(data, fieldName)),
      setInput: (input_name, input_value) => dispatch(setInputAction(input_name, input_value)),
      getAllOrgUnits: () => dispatch(getAllOrgUnitsAction()),
      clearSearchDirectoryInfo: () => dispatch(clearSearchDirectoryInfoAction()),
      clearModal: () => dispatch(clearModalAction()),
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(SearchEmployeeModal)